import { color } from '../../../../../../utility/constant/color.constant'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { Helper, WindowElement } from '../../../../../../classes/helper'
import { useMontage } from '../../../../../../context/montage.context'

interface Props {
  positionX: number
  isGlass: boolean
  isSlanted: boolean
}

export const WindowsSideGlassBottom = ({
  positionX,
  isGlass,
  isSlanted,
}: Props) => {
  const { measure, night, ego } = useMontage()
  const { height, deltaY } = WindowElement.shapePositions(measure)
  const windowsSideWidth = WindowElement.windowsSideWidthSpecial(
    measure,
    isSlanted
  )

  if (!isGlass) return null

  return (
    <mesh
      position={[
        Helper.convertToMeter(measure.userWidth / 2 - cover.bar.width / 2),
        Helper.convertToMeter(measure.userHeight / 2 - (height + deltaY) / 2),
        Helper.convertToMeter(
          measure.userDepth! -
            windowsSideWidth / 2 -
            positionX * windowsSideWidth
        ),
      ]}
      castShadow={cover.terraceCover.castShadow}
      rotation={[
        Helper.convertAngleToRadiant(90),
        0,
        Helper.convertAngleToRadiant(90),
      ]}
    >
      <boxGeometry
        args={[
          Helper.convertToMeter(windowsSideWidth),
          Helper.convertToMeter(cover.bar.depth / 10),
          Helper.convertToMeter(measure.userHeight - (height + deltaY)),
        ]}
      />
      <meshPhysicalMaterial
        color={color.white}
        transparent
        envMapIntensity={ego?.ego || night?.night ? 0.03 : 1}
        opacity={ego?.ego || night?.night? 0.4 : 0.5}
        metalness={ego?.ego || night?.night? 1 : 0.5}
        roughness={0}
      />
    </mesh>
  )
}
